import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeaturedWorks from "./components/FeaturedWorks";
import Categories from "./components/Categories";
import Collections from "./components/Collections";
import Artists from "./components/Artists";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <FeaturedWorks />
        <Categories />
        <Collections />
        <Artists />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
    </>
  );
}